import axios from "axios";


export const getTransportCompanies = async () => {
    const response = await axios.get("api/transportCompanies");
    const result = response.data;
    return result;
}

